import HttpRequest from "../request";
import type {
    EnterpriseBalanceAlertDismissParams,
    EnterpriseBalanceAlertResponse,
    EnterpriseBalanceAlertSaveParams,
    EnterpriseInviteLinkList,
    EnterpriseTargetInvite,
    FileItem,
    EnterpriseInfo,
    EnterpriseMember,
    EnterpriseSite,
    PresetTermEntry,
    PresetTermHeader,
    PrioritySupportConfig,
} from "./types";
import type { LegacyMemberResult } from "../LegacyEnterpriseServer/types";
import { AccountRecordApi, AccountArtApi } from "../api";
import type { Response } from "../request";
import eventBus from 'vue3-eventbus'

export default {
    getRequestAccountUseFilePageList(params: {nextPageId?: number, pageSize: number, prevPageId?: number}): Promise<Response<FileItem>> {
        return HttpRequest.post(AccountRecordApi.getTranslateRecordList, params)
    },
    // 订单
    getOrderNoList(params: {nextPageId?: number, pageSize: number, prevPageId?: number}): Promise<Response<FileItem>> {
        return HttpRequest.post(AccountRecordApi.getOrderNoList, params)
    },
    // 创建企业
    createAccountEnterprise(params: {businessName: string}): Promise<Response<EnterpriseInfo>> {
        return HttpRequest.post(AccountRecordApi.createAccountEnterprise, params)
    },
    // 获取企业信息
    getEnterpriseInfo(verifiedBizTeamId?: number): Promise<Response<EnterpriseInfo>> {
        if (Number.isSafeInteger(verifiedBizTeamId) && verifiedBizTeamId! > 0) {
            // 加入后的 userinfo 已确认归属，但全局资料尚未一起刷新时使用。
            return HttpRequest.get(AccountRecordApi.getEnterpriseInfo, null, {
                headers: { bizTeamId: String(verifiedBizTeamId) },
            })
        }
        return HttpRequest.get(AccountRecordApi.getEnterpriseInfo, null)
    },
    // 加入团队
    joinEnterprise(params: {bizTeamId: number, requestId?: string}): Promise<Response<LegacyMemberResult | any>> {
        return HttpRequest.post(AccountRecordApi.joinEnterprise, params)
    },
    // 查询企业成员列表
    getEnterpriseMemberList(): Promise<Response<EnterpriseMember>> {
        return HttpRequest.get(AccountRecordApi.getEnterpriseMemberList, null)
    },
    // 添加成员
    addMember(params: {
        inviteAccount: string,
        aliasName: string,
        permission: string,
        roleType: number,
        region?: EnterpriseSite,
        requestId?: string,
    }): Promise<Response<LegacyMemberResult | any>> {
        return HttpRequest.post(AccountRecordApi.addMember, params)
    },
    getEnterpriseInviteLinks(): Promise<Response<EnterpriseInviteLinkList>> {
        return HttpRequest.get(AccountRecordApi.getEnterpriseInviteLinks, null)
    },
    getEnterpriseWebSites(): Promise<Response<Partial<Record<EnterpriseSite, string>>>> {
        return HttpRequest.get(AccountRecordApi.getEnterpriseWebSites, null)
    },
    regenerateEnterpriseInviteLink(params: {region: EnterpriseSite}): Promise<Response<EnterpriseInviteLinkList>> {
        return HttpRequest.post(AccountRecordApi.regenerateEnterpriseInviteLink, params)
    },
    createEnterpriseTargetInvite(params: {
        region: EnterpriseSite,
        inviteAccount: string,
        aliasName?: string,
        roleType?: number,
        permission?: number,
    }): Promise<Response<EnterpriseTargetInvite>> {
        return HttpRequest.post(AccountRecordApi.createEnterpriseTargetInvite, params)
    },
    revokeEnterpriseTargetInvite(params: {inviteId: number, region?: EnterpriseSite}): Promise<Response<any>> {
        return HttpRequest.post(AccountRecordApi.revokeEnterpriseTargetInvite, params)
    },
    removeEnterpriseTargetInvite(params: {inviteId: number, region?: EnterpriseSite}): Promise<Response<any>> {
        return HttpRequest.post(AccountRecordApi.removeEnterpriseTargetInvite, params)
    },
    acceptEnterpriseInviteLink(params: {token: string}): Promise<Response<any>> {
        return HttpRequest.post(AccountRecordApi.acceptEnterpriseInviteLink, params)
    },
    // 编辑成员
    editMember(params: {memberId: number, aliasName: string, permission: string, roleType: number | null}): Promise<Response<any>> {
        return HttpRequest.post(AccountRecordApi.editMember, params)
    },
    // 删除成员
    deleteAccountMember(params: {memberId: number, requestId?: string}): Promise<Response<any>> {
        return HttpRequest.post(AccountRecordApi.deleteMember, params)
    },
    // 解散企业
    deleteEnterprise(): Promise<Response<any>> {
        return HttpRequest.post(AccountRecordApi.deleteEnterprise, {})
    },
    // 退出企业
    quitEnterprise(): Promise<Response<any>> {
        return HttpRequest.post(AccountRecordApi.quitEnterprise, {})
    },
    getEnterpriseBalanceAlert(): Promise<Response<EnterpriseBalanceAlertResponse>> {
        return HttpRequest.get(AccountRecordApi.getBalanceAlert, null)
    },
    saveEnterpriseBalanceAlert(params: EnterpriseBalanceAlertSaveParams): Promise<Response<EnterpriseBalanceAlertResponse>> {
        return HttpRequest.post(AccountRecordApi.saveBalanceAlert, params)
    },
    dismissEnterpriseBalanceAlert(params: EnterpriseBalanceAlertDismissParams): Promise<Response<EnterpriseBalanceAlertResponse>> {
        return HttpRequest.post(AccountRecordApi.dismissBalanceAlert, params)
    },
    getPrioritySupportConfig(): Promise<Response<PrioritySupportConfig>> {
        return HttpRequest.get(AccountRecordApi.getPrioritySupportConfig, null)
    },
    // 删除文件
    deleteFile(params: {thisId: number}): Promise<Response<any>> {
        return HttpRequest.post(AccountRecordApi.deleteFile, params)
    },
    // 批量删除文件
    deleteFiles(params: {deleteIds: string}): Promise<Response<any>> {
        return HttpRequest.post(AccountRecordApi.deleteFiles, params)
    },
    // 术语库相关接口
    getCreateTerm(params: any): Promise<Response<any>> {
        return HttpRequest.post(AccountArtApi.getCreateTerm, params)
    },
    getUserTermlist(params: any): Promise<Response<any>> {
        return HttpRequest.post(AccountArtApi.getUserTermlist, params)
    },
    getUserSearchTermlist(params: any): Promise<Response<any>> {
        return HttpRequest.post(AccountArtApi.getUserSearchTermlist, params)
    },
    getDeleteTerm(params: any): Promise<Response<any>> {
        return HttpRequest.post(AccountArtApi.getDeleteTerm, params)
    },
    getEditTerm(params: any): Promise<Response<any>> {
        return HttpRequest.post(AccountArtApi.getEditTerm, params)
    },
    getTermentrylist(params: any): Promise<Response<any>> {
        return HttpRequest.post(AccountArtApi.getTermentrylist, params)
    },
    getAddTermentry(params: any): Promise<Response<any>> {
        return HttpRequest.post(AccountArtApi.getAddTermentry, params)
    },
    getDeleteTermentry(params: any): Promise<Response<any>> {
        return HttpRequest.post(AccountArtApi.getDeleteTermentry, params)
    },
    getEditTermentry(params: any): Promise<Response<any>> {
        return HttpRequest.post(AccountArtApi.getEditTermentry, params)
    },
    getTermImportterm(params: any): Promise<Response<any>> {
        return HttpRequest.post(AccountArtApi.getTermImportterm, params)
    },
    getCheckTermName(params: any): Promise<Response<any>> {
        return HttpRequest.get(AccountArtApi.getCheckTermName, params)
    },
    getCheckTermKeyName(params: any): Promise<Response<any>> {
        return HttpRequest.get(AccountArtApi.getCheckTermKeyName, params)
    },
    getExportExcelTerm(params: any): Promise<Response<any>> {
        return HttpRequest.post(AccountArtApi.getExportExcelTerm, params)
    },
    getArtInfos(params: any): Promise<Response<any>> {
        return HttpRequest.get(AccountArtApi.getArtInfos, params)
    },
    getArtImportentry(params: any): Promise<Response<any>> {
        return HttpRequest.post(AccountArtApi.getTermImportentry, params)
    },
    getPresetTermList(params: {sourceLang: string; targetLang: string}): Promise<Response<PresetTermHeader>> {
        return HttpRequest.get(AccountArtApi.getPresetTermList, params)
    },
    getPresetTermEntryList(params: {presetKey: string; sourceLang: string; targetLang: string}): Promise<Response<PresetTermEntry>> {
        return HttpRequest.get(AccountArtApi.getPresetTermEntryList, params)
    },
    importPresetTerms(params: {presetKeys: string[]; sourceLang: string; targetLang: string}): Promise<Response<any>> {
        return HttpRequest.post(AccountArtApi.getPresetTermImport, params)
    },
    getAccountFileCompare(params: any): Promise<Response<any>> {
        return HttpRequest.get(AccountArtApi.getAccountFileCompare, params)
    }
}
